// Not the agent artifact's key: the two surfaces default weekends differently, and each
// writes its whole Customize object, so a shared key would flip the other's default.
export const preferencesKey = (userId: number) => `my_work_this_week_calendar_prefs:${userId}`;

// Full set, because the calendar takes `customize` whole: a missing flag would read as false.
const DEFAULT_CUSTOMIZE = { showSubtasks: true, showMeetings: true, showWeekends: true };

const isObject = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const asObject = (value: unknown) => (isObject(value) ? value : {});

const readSaved = (userId: number) => {
  try {
    return asObject(JSON.parse(window.localStorage.getItem(preferencesKey(userId)) ?? 'null'));
  } catch {
    return {};
  }
};

/** The user's saved preferences, with weekends shown unless they chose otherwise. */
export const initialPreferences = (userId: number) => {
  const saved = readSaved(userId);
  return { ...saved, customize: { ...DEFAULT_CUSTOMIZE, ...asObject(saved.customize) } };
};

export const savePreferences = (userId: number, preferences: unknown) => {
  try {
    window.localStorage.setItem(preferencesKey(userId), JSON.stringify(preferences));
  } catch {
    // Private mode or full storage: the choice lasts until reload.
  }
};
